export default __webpack_public_path__ + "static/media/psi.38fdc9f5.png";